import React from "react";
import { WithAPICall } from "../utils/apiUtil";
import {
  Alert,
  AlertTitle,
  Button,
  Card,
  IconButton,
  LinearProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { View500 } from "src/sections/error";
import { LoadingButton } from "@mui/lab";
import cogoToast from "cogo-toast";
import { Box, Stack } from "@mui/system";
import Iconify from "src/components/iconify";
import _ from "lodash";
import { copyToClipboard } from "../utils/fn";

class ChatList extends React.Component {
  state = {
    isLoading: true,
    isError: false,
    currentUser: null,
    threads: [],
    personas: [],
    newThreadType: null,
    isCreatingNewThread: false,
  };
  componentDidMount() {
    this.getUser();
  }
  getUser = async () => {
    try {
      let r = await this.props.apiCallPost("/harley/getCurrentUser", {});
      this.setState({ currentUser: r }, () => {
        this.getMyThreads();
      });
    } catch (error) {
      this.setState({ currentUser: null, isLoading: false, isError: true });
    }
  };
  getMyThreads = async () => {
    try {
      let r = await this.props.apiCallPost("/harley/getMyThreads", {});
      this.setState({ threads: r }, () => {
        this.getPersonas();
      });
    } catch (error) {
      this.setState({ threads: null, isLoading: false, isError: true });
    }
  };
  getPersonas = async () => {
    try {
      let r = await this.props.apiCallPost("/harley/getPersonas", {});
      if (!this.state.currentUser.hasDataExplorer) {
        r.splice(r.length - 1, 1);
      }
      this.setState({ personas: r, isLoading: false });
    } catch (error) {
      this.setState({ personas: null, isLoading: false, isError: true });
    }
  };
  createNewThread = async () => {
    try {
      this.setState({
        isCreatingNewThread: true,
      });
      let r = await this.props.apiCallPost("/harley/createNewThread", {
        persona: this.state.newThreadType,
      });
      this.setState(
        {
          isCreatingNewThread: false,
          newThreadType: null,
          threads: [r, ...this.state.threads],
        },
        () => {
          window.location.href = `/${r._id}`;
        }
      );
    } catch (error) {
      this.setState({ threads: null, isLoading: false, isError: true });
    }
  };
  shareThread = async (id, e) => {
    e.preventDefault();
    try {
      this.setState({
        isSharing: true,
      });
      let r = await this.props.apiCallPost("/harley/shareThread", {
        threadId: id,
      });
      let url = `https://harley.newchart.care/${id}`;

      copyToClipboard(url)
        .then(() => {
          cogoToast.success("Link copied to clipboard");
        })
        .catch((error) => {
          cogoToast.error(
            "Failed to copy URL. This is an iOS issue. Please share the URL directly."
          );
        });

      this.setState({
        isSharing: false,
        hovering: false,
      });
    } catch (error) {
      this.setState({
        isSharing: false,
      });
      cogoToast.error("Error sharing thread");
    }
  };
  renderHeaderAlert = () => {
    return (
      <Stack spacing={2}>
        <Typography variant="h6">Welcome to the Harley Playground!</Typography>
        <Alert severity="info">
          <AlertTitle>Important Notes</AlertTitle>
          Harley is an AI assistant that can help you with a variety of tasks.
          This playground showcases some of those capabilities. Not all modes
          can do all tasks. Most importantly, Harley is <b>not</b> a human
          expert and therefore be careful before using it for any critical
          tasks. For the best experience, please use the latest version of
          Google Chrome.
        </Alert>
      </Stack>
    );
  };
  renderTableOfThreads = () => {
    if (this.state.threads.length === 0) {
      return (
        <Card
          sx={{
            boxShadow: 3,
            m: 2,
            p: 2,
            rounded: 2,
          }}
        >
          No threads yet. Click on one of the options above to get started.
        </Card>
      );
    }
    let threads = this.state.threads;
    let isAdmin = this.state.currentUser.isAdmin;

    return (
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Conversation</TableCell>
            <TableCell>Model</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {threads.map((thread, threadIndex) => {
            let title = thread.title;
            if (!title) {
              title = "New Conversation";
            }
            let persona = thread.persona;
            let personaIdx = _.findIndex(this.state.personas, { tag: persona });
            let personaName = "";
            if (personaIdx !== -1) {
              personaName = this.state.personas[personaIdx].niceName;
            }
            let messages = thread.messages;
            let numMessages = messages.length;
            let linkButton = null;
            let shareButton = (
              <IconButton
                onClick={(e) => {
                  this.shareThread(thread._id, e);
                }}
              >
                <Iconify icon="mi:share" />
              </IconButton>
            );
            if (!numMessages) {
              linkButton = (
                <Button
                  variant="contained"
                  color="secondary"
                  href={`/${thread._id}`}
                  startIcon={<Iconify icon="iconoir:system-restart" />}
                >
                  Start Conversation
                </Button>
              );
              shareButton = null;
            }
            let nameElem = null;
            if (isAdmin) {
              nameElem = (
                <Typography variant="caption">
                  {thread?.userId?.name}
                </Typography>
              );
            }
            return (
              <TableRow
                key={threadIndex}
                sx={{
                  "&:hover": {
                    backgroundColor: "#D4F17E",
                  },
                  borderBottom: "2px solid #f0f0f0",
                }}
                onClick={() => {
                  window.location.href = `/${thread._id}`;
                }}
              >
                <TableCell>
                  <Stack spacing={1} direction="row" alignItems={"center"}>
                    <Button
                      href={`/${thread._id}`}
                      sx={{
                        textDecoration: "none !important",
                        color: "inherit !important",
                        "&:hover": {
                          textDecoration: "none !important",
                        },
                      }}
                    >
                      <Typography variant="overline">{title}</Typography>
                    </Button>
                    {linkButton} {shareButton}
                  </Stack>
                </TableCell>
                <TableCell>
                  <Stack spacing={1}>
                    <Typography variant="caption">{personaName}</Typography>
                    {nameElem}
                  </Stack>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    );
  };
  renderCreateNewThread = () => {
    let caps = this.state.personas;
    if (!caps || !caps.length) {
      return null;
    }
    let newThreadType = this.state.newThreadType;
    let createElem = null;
    if (newThreadType) {
      let elem = _.find(caps, { tag: newThreadType });
      if (!elem) {
        createElem = null;
      }
      createElem = (
        <Stack>
          <Typography variant="subtitle1">{elem.niceName}</Typography>
          <Typography variant="caption">{elem.description}</Typography>

          <LoadingButton
            onClick={this.createNewThread}
            loading={this.state.isCreatingNewThread}
          >
            Start!
          </LoadingButton>
        </Stack>
      );
    }
    return (
      <Card
        sx={{
          boxShadow: 3,
          m: 2,
          p: 2,
          rounded: 2,
        }}
      >
        <Stack spacing={2}>
          <Stack spacing={1} direction="row" alignItems="center">
            <Typography variant="overline">Start A New Conversation</Typography>
          </Stack>
          <Box
            rowGap={2}
            columnGap={2}
            display="grid"
            gridTemplateColumns={{
              xs: "repeat(2, 1fr)",
              sm: "repeat(3, 1fr)",
              md: "repeat(4, 1fr)",
              lg: "repeat(4, 1fr)",
              xl: "repeat(5, 1fr)",
            }}
          >
            {caps.map((eachCap, capIdx) => {
              let cardSx = {
                p: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                "&:hover": {
                  backgroundColor: "#D4F17E",
                  boxShadow: 5,
                },
              };
              if (this.state.newThreadType === eachCap.tag) {
                cardSx = {
                  p: 2,
                  boxShadow: 3,
                  backgroundColor: "success.light",
                  textColor: "success.dark",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                };
              }
              return (
                <Card
                  sx={cardSx}
                  key={capIdx}
                  onClick={() => {
                    if (this.state.newThreadType === eachCap.tag) {
                      this.setState({ newThreadType: null });
                    } else {
                      this.setState({ newThreadType: eachCap.tag });
                    }
                  }}
                >
                  <Stack
                    spacing={0.5}
                    direction="row"
                    alignItems="center"
                    justifyContent={"space-between"}
                  >
                    <Iconify icon={eachCap.icon} width={22} />
                    <Typography variant="overline">
                      {" "}
                      {eachCap.niceName}
                    </Typography>
                  </Stack>
                </Card>
              );
            })}
          </Box>
          {createElem}
        </Stack>
      </Card>
    );
  };

  render() {
    if (this.state.isLoading) {
      return <LinearProgress />;
    }
    if (this.state.isError) {
      return <View500 />;
    }
    return (
      <Paper
        sx={{
          padding: "10px",
        }}
      >
        {this.renderHeaderAlert()}
        {this.renderCreateNewThread()}
        {this.renderTableOfThreads()}
      </Paper>
    );
  }
}

export default WithAPICall(ChatList);
